import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Typography
} from 'antd';
import React, { useState } from 'react';
import '../../../components/Common/Form.css';
import { countryList } from '../../../data/countryList';

const { Text } = Typography;

const allLabel = 'All';

const getCountryAmountLabel = (countryName) => `value_${countryName}`;
const getCountryCurrencyLabel = (countryName) => `currency_${countryName}`;
const getCountrystrikeThroughAmountLabel = (countryName) =>
  `strikethrough_${countryName}`;
const getCountryLocaliseBasePriceLabel = (countryName) =>
  `localiseBasePrice_${countryName}`;

const formValuesToPromoCode = (formValues) => {
  const countryWisePrice = [];
  const countriesNames = formValues.countriesNames;
  if (countriesNames) {
    for (const countryName of countriesNames) {
      if (countryName != allLabel) {
        const amountPropertyName = getCountryAmountLabel(countryName);
        const currencyPropertyName = getCountryCurrencyLabel(countryName);
        const strikeThroughAmountPropertyName = getCountrystrikeThroughAmountLabel(
          countryName
        );
        const localiseBasePricePropertyName = getCountryLocaliseBasePriceLabel(
          countryName
        );
        const amount = formValues[amountPropertyName];
        const currency = formValues[currencyPropertyName];
        const strikeThroughAmount =
          formValues[strikeThroughAmountPropertyName];
        const localiseBasePrice =
          formValues[localiseBasePricePropertyName];

        delete formValues[amountPropertyName];
        delete formValues[currencyPropertyName];
        delete formValues[strikeThroughAmountPropertyName];
        delete formValues[localiseBasePrice];

        countryWisePrice.push({
          country: countryName,
          amount: amount,
          currency: currency,
          strikeThroughAmount: strikeThroughAmount,
          localiseBasePrice: localiseBasePrice
        });
      }
    }
    delete formValues.countriesNames;
  }
  return {
    ...formValues,
    countryWisePrice: countryWisePrice
  };
};

const promoCodeToFormValues = (promoCode) => {
  const formValues = Object.assign({}, promoCode);
  const countriesNames = [];
  const countryWisePrice = promoCode.countryWisePrice
    ? promoCode.countryWisePrice.filter(
        (discount) => !!discount && discount.country
      )
    : [];
  if (countryWisePrice) {
    for (const discount of countryWisePrice) {
      const countryName = discount.country;
      countriesNames.push(countryName);
      const amountPropertyName = getCountryAmountLabel(countryName);
      const currencyPropertyName = getCountryCurrencyLabel(countryName);

      formValues[amountPropertyName] = discount.value;
      formValues[currencyPropertyName] = discount.currency;
    }
  }

  return {
    ...formValues,
    countriesNames: countriesNames
  };
};

const PricingOptionForm = ({
  initialValues,
  onSubmit,
  status,
  type,
  setStatus,
  maxValue
}) => {
  const [form] = Form.useForm();
  const initialFormValues = promoCodeToFormValues(initialValues);
  const [maxDepositPercent, setDepositMaxPercent] = useState(maxValue);
  const [selectedCountries, setSelectedCountries] = useState(
    initialFormValues.countriesNames
  );

  const allOptions = [{ label: allLabel, value: allLabel }];
  const countriesNames = countryList.map((country) => ({
    label: country.name,
    value: country.name
  }));
  const configurableCountries = selectedCountries.filter(
    (countryName) => countryName != allLabel
  );

  const typeChangeHandler = (value) => {
    value === 'percent'
      ? setDepositMaxPercent(100)
      : setDepositMaxPercent(Number.MAX_SAFE_INTEGER);
  };

  const onFinish = (formValues) => {
    const promoCodePayload = formValuesToPromoCode(formValues);
    onSubmit(promoCodePayload);
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 15 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
    }
  };
  return (
    <div className="course-add-form">
      <Form
        {...formItemLayout}
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={initialFormValues}>
        <section>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Type/Tag"
                name="type"
                rules={[
                  {
                    required: true,
                    message: 'Please Input Type!'
                  }
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={12}>
              <Form.Item
                label="Global Currency"
                name="currency"
                rules={[
                  {
                    required: true,
                    message: 'Please Input Global Currency!'
                  }
                ]}>
                <Input disabled={true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Global Price"
                name="total"
                rules={[
                  { required: true, message: 'Please Input Global Price!' }
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                label="Deposit Type"
                name={['deposit', 'type']}
                rules={[{ required: true }]}>
                <Select onChange={(value) => typeChangeHandler(value)}>
                  <Select.Option value="percent">Percent</Select.Option>
                  <Select.Option value="amount">Amount</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Deposit value"
                name={['deposit', 'value']}
                rules={[
                  {
                    required: true,
                    message: 'Please input deposit value!'
                  }
                ]}>
                <InputNumber min={0} max={maxDepositPercent} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                label="Global Strike Through Price"
                name="strikeThroughTotal">
                <Input placeholder="Strike Through Price"></Input>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                label="Countries"
                name="countriesNames"
                required={false}>
                <Select
                  name="countriesNames"
                  options={[...countriesNames]}
                  placeholder={'Select Countries'}
                  mode="multiple"
                  notFoundContent={null}
                  filterOption={(input, option) =>
                    option.label
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={setSelectedCountries}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              {configurableCountries.map((countryName) => (
                <Form.Item label={countryName} name="countryWisePrice">
                  <Row>
                    <Col span={6}>
                      <Form.Item
                        name={getCountryCurrencyLabel(countryName)}
                        required={true}
                        style={{
                          display: 'inline-block',
                          marginBottom: 0
                        }}>
                        <Input placeholder="Currency"></Input>
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        name={getCountryAmountLabel(countryName)}
                        required={true}
                        style={{
                          display: 'inline-block',
                          marginBottom: 0
                        }}>
                        <InputNumber min={0} placeholder="Amount" />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        name={getCountrystrikeThroughAmountLabel(
                          countryName
                        )}
                        required={false}
                        style={{
                          display: 'inline-block',
                          marginBottom: 0
                        }}>
                        <Input placeholder="Strike Through Price"></Input>
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        name={getCountryLocaliseBasePriceLabel(
                          countryName
                        )}
                        required={false}
                        valuePropName="checked">
                        <Checkbox defaultChecked={false} />
                        Localize Base Price
                      </Form.Item>
                    </Col>
                  </Row>
                  <Divider></Divider>
                </Form.Item>
              ))}
            </Col>
          </Row>

          <Row>
            <Col span={6}>
              <Form.Item name="discountEnabled" valuePropName="checked">
                Enable Discounts &nbsp;
                <Checkbox
                  defaultChecked={initialFormValues.discountEnabled}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="creditsEnabled" valuePropName="checked">
                Enable Credits &nbsp;
                <Checkbox
                  defaultChecked={initialFormValues.creditsEnabled}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="localiseForAllCountries"
                valuePropName="checked">
                Localize For All Countries &nbsp;
                <Checkbox
                  defaultChecked={
                    initialFormValues.localiseForAllCountries
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </section>

        {status.type === 'ERROR' ? (
          <Text type="danger">{status.message}</Text>
        ) : null}
        {status.type === 'SUCCESS' ? (
          <Text type="success">Successful!</Text>
        ) : null}
        <br />

        <Row justify="end" gutter={12}>
          <Col>
            <Button type="primary" htmlType="submit">
              {type}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default PricingOptionForm;
